import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: (p) => p.spacing(1),
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[400],
  backgroundColor: (p) => p.palette.grey[100],
  borderRadius: (p) => p.spacing(1),
  height: (p) => p.spacing(4.5),
  pointerEvents: 'none',
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
